import { isMongoId } from "validator";
import { z } from "zod";

export const withApiAttributes = z.object({
  _id: z.string().refine((val) => isMongoId(val)),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
